(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.loading-card-simple', ['pp.widgets-templates']);

ngModule.component('ppLoadingCardSimple', {
    templateUrl: 'widgets/_angular/loading-card-simple/loading-card-simple.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);